
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.838 41.14H7.455c-1 0-1.81-.806-1.81-1.802V19.825c0-.996.81-1.802 1.81-1.802h45.383c1 0 1.81.806 1.81 1.802v19.513a1.818 1.818 0 01-1.81 1.802zM7.645 39.149h44.993V20.024H7.645v19.125z"}}),_c('path',{attrs:{"d":"M24.932 28.367c-.03-.19-.09-.359-.19-.518-.1-.16-.22-.289-.37-.408-.15-.12-.31-.21-.49-.279-.18-.07-.38-.1-.58-.1-.37 0-.68.07-.94.21-.26.139-.47.328-.63.567-.16.24-.28.508-.35.817a4.22 4.22 0 00-.11.945c0 .309.04.618.11.906.07.289.19.558.35.797.16.239.37.428.63.567.26.14.57.21.94.21.5 0 .89-.16 1.17-.459.28-.308.45-.706.52-1.194h1.58c-.04.467-.15.886-.32 1.254a2.8 2.8 0 01-.69.956c-.29.259-.62.468-1 .607-.38.14-.8.21-1.26.21-.58 0-1.09-.1-1.54-.3-.45-.199-.83-.477-1.149-.816a3.744 3.744 0 01-.72-1.224 4.396 4.396 0 01-.25-1.504c0-.547.08-1.055.25-1.533.17-.478.41-.896.72-1.244.31-.349.69-.628 1.15-.827.45-.199.97-.298 1.54-.298.41 0 .8.06 1.16.179.37.12.69.288.98.517.29.23.53.498.71.837.19.328.309.717.359 1.145h-1.58v-.02zM27.692 25.878h1.64v2.847h3.01v-2.847h1.639v7.407h-1.64v-3.196h-3.01v3.196h-1.64v-7.407zM40.64 25.878v1.374h-3.6v1.712h3.12v1.265h-3.12v3.066H35.4v-7.417h5.24z"}})])
          )
        }
      }
    